import { BlogWrapper } from "../../../../src/collections/blog/Blog.style.js";
import { Link } from "gatsby";
import Button from "../../../../src/reusecore/Button";
import Blockquote from "../../../../src/reusecore/Blockquote";
import { Blog } from "../../../../src/collections/blog/2023/08-21-layer5-badge-program/blog.style";
import BadgesGH from "../../../../src/collections/blog/2023/08-21-layer5-badge-program/badges-modal.png";
import RecognitionProgram from "../../../../src/collections/blog/2023/08-21-layer5-badge-program/recognition-program.png";
import Playfield from "../../../../src/collections/blog/2023/08-21-layer5-badge-program/layer5-community-playfield.webp";
import RecognitionBanner from "../../../../src/collections/blog/2023/08-21-layer5-badge-program/recognition-banner.webp";
import * as React from 'react';
export default {
  BlogWrapper,
  Link,
  Button,
  Blockquote,
  Blog,
  BadgesGH,
  RecognitionProgram,
  Playfield,
  RecognitionBanner,
  React
};